module.exports = __webpack_public_path__ + "static/media/stockhausen_hbk_05.d899e470.jpg";